<template>
  <div class="reporting-toolbar border-top border-bottom">
    <div class="container-fluid px-3 d-flex">
      <!-- Left -->
      <div class="flex-grow-1 d-flex align-items-center">
        <div>
          <h4 class="mb-0">{{ automatedReportResult.filename }}</h4>
        </div>
      </div>
      <!-- / Left -->
    </div>
  </div>
</template>

<script>
export default {
  name: "AutomatedReportToolbar",
  props: ['automatedReportResult'],
  methods: {},
  computed: {}
}
</script>

<style scoped>
.reporting-toolbar {
  border-top: 1px #ebeff3 solid !important;
  border-bottom: 1px #cfd7df solid !important;
  padding-top: 16px;
  padding-bottom: 16px;
  box-shadow: 0 2px 4px 0 rgba(24, 50, 71, .08);
  z-index: 1;
}
</style>